import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const hasPermission = (userPermissions, module, operations = ["read"]) => {
  const entry = userPermissions.find((p) => p.module === module);
  if (!entry) return false; // module not in array = no access at all
  if (entry.operations.length === 0) return false; 
  
  return entry.operations.some((op) => operations.includes(op));
}

const Authmiddleware = (props) => {
  const { module, operations } = props;
  const { auth } = useAuth();

  console.log(auth);

  if (!auth) {
    return <Navigate to={{ pathname: "/login", state: { from: props.location } }} />;
  }

  const userPermissions = JSON.parse(localStorage.getItem("user")).permissions || [];

  if (module && operations && !hasPermission(userPermissions, module, operations)) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  return (<React.Fragment>
   {props.children}
  </React.Fragment>);
};

export default Authmiddleware;
